import React, {Component} from "react"

import Loading from "@irati/ui/src/Loading"
import authentication from "@irati/auth"
import {getMedicalAccount} from "@irati/medical/services/medical"
import medicalTracking from "@irati-tracking/medical"
import {MedicalDCAUser} from "@irati/medical/types"

import GetStarted from "./GetStarted"
import ActivationCode from "./ActivationCode"
import MyMedical from "./MyMedical"

interface Props {}

interface State {
  load: Promise<void>,
  user: MedicalDCAUser
}

class Home extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      load: getMedicalAccount(authentication.user())
        .then((user: MedicalDCAUser) => {
          this.setState({user})
        })
        .catch((err: PBError) => {
          if (err.response.status !== 404) {
            throw err
          }
        }),
      user: {
        activated: null,
        activationCode: null
      }
    }
  }

  handleCreateMedicalUser = (user: MedicalDCAUser) => {
    medicalTracking.detailsSubmitted(user.activationCode)
    this.setState({user})
  }

  getComponent = () => {
    const {user} = this.state

    if (user.activated) {
      return <MyMedical user={user} />
    }
    if (user.activationCode) {
      return <ActivationCode user={user} />
    }
    return <GetStarted onCreateMedicalUser={this.handleCreateMedicalUser} />
  }

  render() {
    const {load} = this.state
    return <Loading load={load}>{this.getComponent()}</Loading>
  }
}

export default Home
